import { createFileRoute, Outlet, Link, useLocation } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

export const Route = createFileRoute('/$org/user/me')({
    component: UserMeLayout,
})

function UserMeLayout() {
    const { org } = Route.useParams()
    const location = useLocation()
    const { t } = useTranslation('users')

    // Security holds two-step verification and the sessions (spec
    // 2026-10-01-03); /user/me/sessions, its former address, still opens it.
    const tabs: { label: string; path: string; aliases?: string[]; testId?: string }[] = [
        { label: t('profile.title_own'), path: `/${org}/user/me/profile` },
        { label: t('mfa.security.tab', { ns: 'auth' }), path: `/${org}/user/me/security`, aliases: [`/${org}/user/me/sessions`], testId: 'security' },
        { label: t('passkeys.title', { ns: 'auth' }), path: `/${org}/user/me/passkeys` },
        { label: t('breadcrumb.pat'), path: `/${org}/user/me/pat` },
        { label: t('breadcrumb.email_ingestion'), path: `/${org}/user/me/email-ingestion` },
        { label: t('notifications.tab'), path: `/${org}/user/me/notifications`, testId: 'notifications' },
    ]

    const activeTab = tabs.find(tab =>
        [tab.path, ...(tab.aliases ?? [])].some(p => location.pathname.startsWith(p))
    )?.path ?? tabs[0].path

    return (
        <div className="container mx-auto py-8 max-w-4xl">
            {/* On a phone the tabs are wider than the screen: the row scrolls inside itself. */}
            <nav className="mb-6 overflow-x-auto">
                <div className="inline-flex h-10 w-max min-w-full items-center md:min-w-0 justify-center rounded-md bg-muted p-1 text-muted-foreground">
                    {tabs.map(tab => (
                        <Link
                            key={tab.path}
                            to={tab.path}
                            data-testid={`user-tab-${tab.testId ?? tab.label.toLowerCase()}`}
                            className={`inline-flex shrink-0 items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 ${
                                activeTab === tab.path
                                    ? 'bg-background text-foreground shadow-sm'
                                    : 'hover:bg-background/50'
                            }`}
                        >
                            {tab.label}
                        </Link>
                    ))}
                </div>
            </nav>
            <Outlet />
        </div>
    )
}
